import React from 'react';
import ReactDOM from 'react-dom';
import './styles/App.css';
import './styles/styleguide.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
